import React, { useEffect, useState } from 'react';

import SignIn from './main-component/SignIn';
import MainLayout from './layout/MainLayout';
import Home from './main-component/Home';
import Loading from './main-component/Loading';
import Utenti from './main-component/Utenti';
import ViewRecord from './main-component/ViewRecord';
import UpdateRecord from './main-component/UpdateRecord';
import {  firebaseConfig } from './config/firebase_config.js';
import {getUserData} from './controller/user.js';
import {initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";

import { createTheme,ThemeProvider  } from '@mui/material/styles';
import { itIT } from '@mui/material/locale';
//import firebase from 'firebase/compat/app';

import { getAuth, setPersistence, browserLocalPersistence, onAuthStateChanged, signOut  } from "firebase/auth";
import {getFirestore} from 'firebase/firestore'; // Importa solo Firestore se è l'unico servizio che desideri utilizzare
import {BrowserRouter, Route, Routes, } from 'react-router-dom'
import { app } from './config/app.js';
import { } from './config/collections/utenti.js';
import { } from './config/collections/candidati.js';

import { remoteLog } from './controller/utils.js';
import { } from './config/collections/guide.js';
import ViewSingleRecord from './main-component/ViewSingleRecord.js';
//import PadTest from './main-component/PadTest.js'; 
import { CreateGuida } from './main-component/Guide/CreateGuida.js';
import {ViewEditGuida } from './main-component/Guide/ViewEditGuida.js';
import CercaCandidato from './main-component/Guide/CercaCandidato.js';
import StoricoGuide from './main-component/Guide/StoricoGuide.js';
import EsamiCandidatoComponent from './main-component/Guide/EsamiCandidato.js';
import SchedaCandidato from './main-component/Guide/SchedaCandidato.js';
import ElencoGuideCandidato from './main-component/Guide/ElencoGuideCandidato.js';

const defaultTheme = createTheme({
  palette: {
    primary: { main: '#1976d2' },
  },
},itIT);
const appFirebase=initializeApp(firebaseConfig);
const analytics = getAnalytics(appFirebase);
app.db = getFirestore (appFirebase); 
const auth=getAuth(appFirebase);
auth.useDeviceLanguage();
//console.log("App config",app);
setPersistence(auth, browserLocalPersistence)
.then(() => {

  return null;
})
.catch((error) => {
  // Handle Errors here.
  const errorCode = error.code;
  const errorMessage = error.message;
  console.log(errorMessage,errorCode);
});


//const ui=new firebaseui.auth.AuthUI(auth);
function App() {
  
  

  
  const [user, setUser]= useState("loading");
  const [tableFilters,setTableFilters] =useState({});
  useEffect(()=> {
    //if (!user && auth.currentUser)
    //  setUser(auth.currentUser);
    onAuthStateChanged(auth, (userFound)  =>{
   //   return;
    //  console.log("Auth state changed",userFound); 
      const foundId=(userFound!=null?userFound.uid:"");
      if (!app.lastUid) app.lastUid="";
      let changed=true;
      //if (user && userFound && typeof(user)!=="undefined" && typeof(userFound)!=="undefined") 
      changed=app.lastUid!==foundId;
      //if (changed && app.lastUid=="") return;
      // console.log("old uid: "+(app.lastUid)+" new uid: "+(foundId));
      
      app.lastUid=(userFound?userFound.uid:"");
      
      
      if (userFound && changed) {
       // console.log("Utente cambiato");
          getUserData(userFound)
          .then((userData) => {
           // console.log("Trovato utente a db",userData);
            if (userData) userFound.db=userData;
            setUser(userFound);
            app.user=userFound;
            remoteLog("login","Utente loggato");
          })
          .catch((error) => {
            console.error('Errore durante il recupero dei dati utente:', error);
          });

      }
      if (!userFound) setUser(null);
      
    });
  },[]);
  return (
    
    <div className="App">
      <header className="App-header">
        
        
        <BrowserRouter>
        <Routes>
        <Route
          path="/login"
          element={<SignIn auth={auth} user={user} setUser={setUser} />}
        />
        <Route
          path="/"
          element={<MainLayout user={user} setUser={setUser} auth={auth} />}>
              <Route path="/" element={<Home  user={user}/>} />
              <Route path="/dashboard/" element={<Home  user={user}/>} />
              <Route path="/usersOld" element={<Utenti  user={user} />} />
           
              <Route path="/guide/" key="guide" element={<CercaCandidato  user={user}/>} />
              <Route path="/guide/crea" element={<CreateGuida user={user} />} />
              <Route path="/guide/view" element={<ViewEditGuida user={user} mode="view" />} />
              <Route path="/guide/scheda" element={<SchedaCandidato user={user} />} />
              <Route path="/guide/storico" element={<StoricoGuide user={user} />} />
              <Route path="/guide/elenco" element={<ElencoGuideCandidato user={user} />} />
              
              <Route path="/candidato/esami" element={<EsamiCandidatoComponent user={user} />} />
              <Route path="/candidati" key="candidati" element={<ViewRecord  user={user} view='table' collectionName='candidati' filters={tableFilters} setFilters={setTableFilters} key='candidati' />} />
              <Route path="/candidati/update" element={<UpdateRecord  user={user} collectionName='candidati' key='candidati' />} />
              <Route path="/candidati/view" element={<ViewSingleRecord  user={user} collectionName='candidati' key='candidati' />} />   
              <Route path="/utenti" element={<ViewRecord  user={user} view='table' collectionName='utenti' filters={tableFilters} setFilters={setTableFilters} key='utenti' />} />
              <Route path="/utenti/view" element={<ViewSingleRecord  user={user} collectionName='utenti'  key='utenti'/>} />
              <Route path="/utenti/update" element={<UpdateRecord  user={user} collectionName='utenti' key='utenti' />} />
              <Route path="/padtest" element={<div   />} />
              <Route path="/archivioGuide" element={<ViewRecord  user={user} view='table' collectionName='guide' filters={tableFilters} setFilters={setTableFilters} key='archivioGuide' />} />
        </Route>
        </Routes>
        </BrowserRouter>
      </header>
    </div>
  );
}

export default App;
export { auth, defaultTheme };
